import React, { useState } from 'react';
import styled, { css } from 'styled-components';

import { Button } from '../../shared/Button/Button';

export const BubbleButton = () => {
  const [isOpen, setIsOpen] = useState(false);
  const [animate, setAnimate] = useState(false); // State to trigger animation

  const handleClick = () => {
    setIsOpen(!isOpen);
    setAnimate(true);

    if (!isOpen) {
      window.parent.postMessage('openChat', '*');
    } else {
      window.parent.postMessage('closeChat', '*');
    }

    setTimeout(() => {
      setAnimate(false);
    }, 300);
  };

  return (
    <BubbleButtonContainer>
      <ChatButton onClick={handleClick} animate={animate}>
        <IconWrapper>{isOpen ? <CloseIcon /> : <ChatIcon />}</IconWrapper>
      </ChatButton>
    </BubbleButtonContainer>
  );
};

const BubbleButtonContainer = styled.div`
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
`;

const ChatButton = styled(Button)`
  border-radius: 50%;
  width: 48px;
  height: 48px;
  padding: 0;
  transition: transform 0.3s ease-in-out;

  ${props =>
    props.animate &&
    css`
      transform: scale(1.1);
    `}
`;

const ChatIcon = styled.i.attrs({
  className: 'fa-regular fa-message fa-lg',
})`
  font-size: 20px;
  font-weight: 500;
`;

const CloseIcon = styled.i.attrs({
  className: 'fa-regular fa-xmark fa-lg',
})`
  font-size: 20px;
  font-weight: 500;
`;

const IconWrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
`;
